"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostToEmailModal = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var PostToEmailModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(PostToEmailModal, _Modal);

  function PostToEmailModal() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PostToEmailModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PostToEmailModal)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.classList = ['modal', 'fade'];
    _this.modalTitleElement = 'h3';
    _this.innerWrapper = false;
    _this.feedbackTypes = [// { value: 'Suggest a Course', title: 'Suggest a Course' },
    {
      value: 'Question',
      title: 'Have a Question'
    }, {
      value: 'Report an Issue',
      title: 'Report an Issue'
    }, {
      value: 'Comment',
      title: 'Make a Comment'
    }];
    _this.withError = false;
    _this.defaultType = null;
    return _this;
  }

  babelHelpers.createClass(PostToEmailModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(PostToEmailModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        element.querySelector('form.row-fluid').addEventListener('submit', function (event) {
          event.preventDefault();
          var pd = {
            form: 1,
            contactType: element.querySelector('input[name=contactType]:checked').value,
            comments: element.querySelector('textarea[name=comments]').value,
            fetch: true
          };
          (0, _fetch.default)(location.href, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(pd)
          }).then(function (d) {
            return d.json().catch(function (e) {
              return {
                state: false,
                postData: pd
              };
            });
          }).then(function (_ref) {
            var state = _ref.state,
                postData = _ref.postData;
            var a = element.querySelector('form > h3 + .alert');

            if (!state) {
              if (!a) {
                a = document.createElement('div');
                a.className = 'alert alert-error';
                a.textContent = 'You must provide a contact type.';
                var t = element.querySelector('form > h3');
                t.parentNode.insertBefore(a, t.nextSibling);
              }
            } else {
              if (a) {
                a.parentNode.removeChild(a);
              }

              (0, _noty.showNotificationText)('Thank you for your feedback.');

              _this2.hide();
            }
          });
        });
        return element;
      });
    }
  }, {
    key: "title",
    get: function get() {
      return "";
    }
  }, {
    key: "modalContent",
    get: function get() {
      var _this3 = this;

      return "\n\t\t\t<form method='post' class='row-fluid'>\n\t\t\t\t<h3 style='text-align: center;'>What kind of feedback?</h3>\n\t\t\t\t".concat(this.withError ? "\n\t\t\t\t\t<div class='alert alert-error'>You must provide a contact type.</div>\n\t\t\t\t" : '', "\n\t\t\t\t<div class='radio-grid'>").concat(this.feedbackTypes.map(function (type) {
        return "\n\t\t\t\t\t\t<label class='radio-item'>\n\t\t\t\t\t\t\t<input type='radio' name='contactType' required value='".concat(type.value, "' ").concat(type.value === _this3.defaultType ? 'checked' : '', ">\n\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t<img src='/t/width=400/height=400/matte=fff0/scale/transparent.png' width='400' height='400' class='img-responsive'>\n\t\t\t\t\t\t\t\t").concat(type.title, "\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t");
      }).join(''), "</div>\n\t\t\t\t<div class='form-group'>\n\t\t\t\t\t<label for='comments' class='sr-only'>Comments</label>\n\t\t\t\t\t<textarea id='comments' name='comments' class='form-control' rows='3' placeholder='tell us about it here...'></textarea>\n\t\t\t\t</div>\n\t\t\t\t<div class='form-group'>\n\t\t\t\t\t<small><strong>Note</strong> <em>This is not an anonymous form. Your account information will be included with your\n\t\t\t\t\t\tsubmission.</em></small>\n\t\t\t\t</div>\n\t\t\t\t<div class='form-action center-block'>\n\t\t\t\t\t<button type='submit' class='btn btn-primary' data-spin='true'>\n\t\t\t\t\t\tSend\n\t\t\t\t\t</button>\n\t\t\t\t\t<input type='hidden' name='form' value='1'>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t");
    }
  }]);
  return PostToEmailModal;
}(_base.default);

exports.PostToEmailModal = PostToEmailModal;
var instance = new PostToEmailModal('postToEmail-modal');
var _default = instance;
exports.default = _default;